import { space as spaceTokens } from '@workday/canvas-kit-react/tokens';
var selector = '& > *:not(style) ~ *:not(style)';
var getSpace = function (value) {
    return spaceTokens[value] || value;
};
export function stack(props) {
    var _a;
    var _b = props.flexDirection, flexDirection = _b === void 0 ? 'row' : _b, spacing = props.spacing;
    var styles = {};
    if (flexDirection === 'column') {
        styles = { marginTop: getSpace(spacing) };
    }
    if (flexDirection === 'column-reverse') {
        styles = { marginBottom: getSpace(spacing) };
    }
    if (flexDirection === 'row') {
        styles = { marginInlineStart: getSpace(spacing) };
    }
    if (flexDirection === 'row-reverse') {
        styles = { marginInlineEnd: getSpace(spacing) };
    }
    return _a = {},
        _a[selector] = styles,
        _a;
}
